import { createRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { rootRoute } from '@/router/root-route';
import JobCreateSuccessPage from '@/features/jobs/job-create-success/JobCreateSuccessPage';

/**
 * Search schema for the post-create success page. `id` is the freshly minted
 * job's UUID, propagated by the create flow so "Continuar editando"
 * lands directly on `/vagas/:id/editar`. Optional so a direct visit (or
 * a stale link from an older build) still renders the page and falls back
 * to the jobs list.
 */
const jobCreateSuccessSearchSchema = z.object({
  id: z.string().uuid().optional(),
});

export const jobCreateSuccessRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/vagas/nova/sucesso',
  validateSearch: jobCreateSuccessSearchSchema,
  component: JobCreateSuccessPage,
});
